import { RESPONSE_STATUS, CLEAR_RESPONSE, GET_PRODUCT } from './homeTypes'

export default (state, action) => {
    switch (action.type) {
        case GET_PRODUCT:
            return {
                ...state,
                all_products: action.payload,
            }
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
